import React from 'react'
import { BoxTabs } from '../../../components/AntdTab/AntdTab'
import GuestList from './GuestList/GuestList'
import Table from './Table/Table'
import Attendees from './Attendees/Attendees'
import FloorPlan from './FloorPlan/FloorPlan'
import RSVP from './RSVP/RSVP'

const GuestDetails = () => {

  const items = [
    {
      key: "1",
      label: "Guest List",
      headerTitle: "Guest",
      children: <GuestList />,
      // onClick: () => {
      //   navigate(".", { state: { headrTitle: "Event Detail" } });
      // },
    },
    {
      key: "2",
      label : "Table",
      headerTitle: "Table",
      children: <Table/>,
    },
    {
      key: "3",
      label : "Attendees",
      headerTitle: "Attendees",
      children: <Attendees/>,
    },
    {
      key: "4",
      label : "Floor Plan",
      headerTitle: "Floor Plan",
      children: <FloorPlan/>,
    },
    {
      key: "5",
      label : "RSVP",
      headerTitle: "RSVP",
      children: <RSVP/>,
    },
  ]
    return (
        <BoxTabs
        items={items}
        changeHeaderOnTab={true}
        // activeKey={state?.activeKey}
        destroyOnBlur
      />
    )
}

export default GuestDetails
